import { Text } from '@doda/io-react/common';
import { JobSelectionInformationResponse } from '@doda/api-client/aspida/@types';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';
import { LightBlueSubTitle } from '../LightBlueSubTitle';
import styles from './index.module.scss';
import { SectionTitle } from '../../SectionTitle';
/**
 * ApplicationMethodのProps
 */
interface Props {
  selectionInformation: JobSelectionInformationResponse;
  jobOfferKind: string;
}

/**
 * 応募方法コンポーネント
 * @param selectionInformation 応募選考
 * @param jobOfferKind 求人種別
 */
export const ApplicationMethod = ({
  selectionInformation,
  jobOfferKind,
}: Props) => {
  const {
    selectionFlows = [],
    selectionProcess,
    conntact,
  } = selectionInformation;
  const methodNotes = DIRECT_METHOD_NOTES;

  return (
    <div>
      <SectionTitle mb="L" border>
        応募方法
      </SectionTitle>
      <SectionItem label="応募方法">
        {jobOfferKind !== '4' && (
          <div
            className={styles['jobSearchDetail-applicationMethod__description']}
          >
            <Text weight="bold">
              本ページ内＜応募する＞ボタンより、必要事項をご入力の上、ご応募ください。
            </Text>
            <ul>
              {methodNotes.map((text) => (
                <li key={text}>
                  <Text color="gray" size="11" style={{ lineHeight: 1.7 }}>
                    {text}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className={styles['jobSearchDetail-applicationMethod__items']}>
          <div
            className={styles['jobSearchDetail-applicationMethod__contentWrap']}
          >
            <LightBlueSubTitle label="選考の流れ" />
            <div>
              <ul className={styles['jobSearchDetail-applicationMethod__list']}>
                {selectionFlows.map(({ text, index }) => (
                  <li
                    key={text}
                    className={
                      styles['jobSearchDetail-applicationMethod__listItem']
                    }
                    data-index={index}
                  >
                    <Text weight="bold">{text}</Text>
                  </li>
                ))}
              </ul>
              {selectionProcess && (
                <div
                  className={
                    styles['jobSearchDetail-applicationMethod__process']
                  }
                >
                  <TextWithLF text={selectionProcess} />
                </div>
              )}
            </div>
          </div>
          {conntact && (
            <div
              className={
                styles['jobSearchDetail-applicationMethod__contentWrap']
              }
            >
              <LightBlueSubTitle label="連絡先" />
              <TextWithLF text={conntact} />
            </div>
          )}
        </div>
      </SectionItem>
    </div>
  );
};

const DIRECT_METHOD_NOTES = [
  '※応募書類は返却いたしませんのでご了承ください。',
  '※提供いただいた個人情報は採用活動のみに使用し、第三者への開示・提供はいたしません。',
  '※求人情報は、掲載期間が過ぎますとサイト上から削除されます。',
  '※応募した求人内容を確認したい場合は、本ページを印刷されるなどのご対応をお願いいたします。',
] as const;
